import BaseEditorElement from '@/components/BlocksEditor/CreateJsBlocksEditor/abstract/BaseEditorElement';
import { Bitmap, Container, Shape } from '@createjs/easeljs';
import CreateJsBlocksEditor from '@/components/BlocksEditor/CreateJsBlocksEditor';
import Events from '@/components/BlocksEditor/CreateJsBlocksEditor/Events';
import Grid from '@/components/BlocksEditor/CreateJsBlocksEditor/Grid';

class ExternalItemActionsView extends BaseEditorElement {
  /**
   * @type {ExternalItem}
   */
  externalItem

  /**
   *
   * @type {easeljs.Container}
   * @private
   */
  _rotateButton = new Container()
  _deleteButton = new Container()
  _copyButton = new Container()

  constructor(externalItem) {
    super()
    this.externalItem = externalItem

    const rotateButtonShape = new Shape()
    rotateButtonShape.graphics
      .beginFill('#FFFFFF')
      .beginStroke('#efefef')
      .drawCircle(0,0, 40)
    this._rotateButton.addChild(rotateButtonShape)
    this._rotateButton.addEventListener('mousedown', this._onRotateClick)
    this._rotateButton.x -= 45

    const rotateIconBitmap = new Bitmap(require('@/assets/images/editor/actions/rotate.png'))
    rotateIconBitmap.scale = 0.7
    rotateIconBitmap.x = -30 * rotateIconBitmap.scale
    rotateIconBitmap.y = -30 * rotateIconBitmap.scale
    this._rotateButton.addChild(rotateIconBitmap)

    this.container.addChild(this._rotateButton)

    const deleteButtonShape = new Shape()
    deleteButtonShape.graphics
      .beginFill('#FFFFFF')
      .beginStroke('#efefef')
      .drawCircle(0,0, 40)
    this._deleteButton.addChild(deleteButtonShape)
    this._deleteButton.addEventListener('mousedown', this._onDeleteClick)
    this._deleteButton.x = 45

    const deleteIconBitmap = new Bitmap(require('@/assets/images/editor/actions/delete.png'))
    deleteIconBitmap.scale = 0.7
    deleteIconBitmap.x = -30 * rotateIconBitmap.scale
    deleteIconBitmap.y = -30 * rotateIconBitmap.scale
    this._deleteButton.addChild(deleteIconBitmap)
    this.container.addChild(this._deleteButton)


    this.container.addChild(this._copyButton)

    this.container.scale = 0
    this._rotateButton.scale = 0

    Grid.Instance.actionsContainer.addChild(this)

    CreateJsBlocksEditor.Instance.addEventListener(Events.ELEMENT_SELECTED, this._onElementSelected)
    Grid.Instance.addEventListener(Events.GRID_MOVED, this._onGridMoved)
  }

  _onGridMoved = (e) => {
    this.draw()
  }

  _onElementSelected = (e) => {
    this.draw()
  }

  _onDeleteClick = (e) => {
    this.externalItem.destroy()
    CreateJsBlocksEditor.Instance.setSelectedElement(null)
  }

  _onRotateClick = (e) => {
    this.externalItem.rotate()
  }

  draw() {
    if (this.externalItem.isSelected() && this.externalItem.isSetuped) {
      this.container.scale = 1 / Grid.Instance.container.scale
      this.updatePosition()
    } else {
      this.container.scale = 0
    }
  }

  updatePosition () {
    const point = {x: this.externalItem.x, y: this.externalItem.y}
    point.y += 74 * this.container.scale

    this.x = point.x
    this.y = point.y

    this._rotateButton.scale = this.externalItem.rotationAvailable ? 1 : 0
  }

  destroy() {
    if (!this.destroyed) {
      Grid.Instance.actionsContainer.removeChild(this)
      CreateJsBlocksEditor.Instance.removeEventListener(Events.ELEMENT_SELECTED, this._onElementSelected)
      Grid.Instance.removeEventListener(Events.GRID_MOVED, this._onGridMoved)

      super.destroy();
    }
  }
}

export default ExternalItemActionsView
